import * as React from 'react';
import { Admin, Resource, usePermissions } from 'react-admin';
import { createTheme } from '@material-ui/core';
import appDataProvider from './providers/dataProvider';
import winners from './components/winners';
import widgets from './components/widgets';
import prizes from './components/lifestylePrizes';
// import affiliates from './components/affiliates';
import appAuthProvider from './providers/authProvider';
import { Login, MyLayout } from './components/common/layout';
import dreamHome from './components/dreamHome';
import propertyReducer from './redux/reducers/propertyReducer';
import blogReducer from './redux/reducers/blogReducer';
import fixedOdds from './components/fixedOdds';
import weeklySubscriptionDraw from './components/weeklySubscriptionDraw';
import users from './components/users';
import blogs from './components/blogs';
import staffUsers from './components/staff';
import categories from './components/categories';
import refferals from './components/refferals';
import competitions from './components/competitions/index';
import home from './components/home/index';
import CompetitionDetails from './components/competitions/CompetitionDetails';
import general from './components/general';
import { landingGeneral } from './components/landingGenerals';
import specialOffers from './components/specialOffers';
import reports from './components/reports';
import bonusDraw from './components/bonusDraw';
import generalContent from './components/generalContent';
import customRoutes from './routes';
import {
  checkPermission,
  checkSubMenuPermissions,
} from './helpers/checkPermissions';

require('dotenv').config();

const THEME = createTheme({
  typography: {
    fontFamily: 'SF UI Display Light',
  },
});

const dataProvider = appDataProvider;
const authProvider = appAuthProvider;

const App = () => {
  // const { permissions } = usePermissions()
  return (
    <Admin
      theme={THEME}
      customReducers={{ property: propertyReducer, blog: blogReducer }}
      customRoutes={customRoutes}
      dataProvider={dataProvider}
      authProvider={authProvider}
      loginPage={Login}
      layout={MyLayout}
    >
      {(permissions) => [
        // <Resource name='homes' {...home} />,
        <Resource name='content' {...generalContent} />,

        checkSubMenuPermissions(permissions, ['Dream home'])
          ? [
              <Resource
                name='dreamHome'
                {...dreamHome}
                options={{ label: 'Prize Management' }}
              />,
            ]
          : null,

        checkSubMenuPermissions(permissions, ['User management'])
          ? [<Resource name='users' {...users} />]
          : null,

        checkSubMenuPermissions(permissions, ['Lifestyle Prizes'])
          ? [<Resource name='prizes' {...prizes} />]
          : null,

        checkSubMenuPermissions(permissions, ['Fixed Odds'])
          ? [<Resource name='fixedOdds' {...fixedOdds} />]
          : null,

        checkSubMenuPermissions(permissions, ['Winners'])
          ? [<Resource name='winners' {...winners} />]
          : null,

        checkSubMenuPermissions(permissions, ['Staff management'])
          ? [<Resource name='staffUsers' {...staffUsers} />]
          : null,

        checkSubMenuPermissions(permissions, ['Referrals'])
          ? [<Resource name='referrals' {...refferals} />]
          : null,

        checkSubMenuPermissions(permissions, ['Competitions'])
          ? [<Resource name='competitions' {...competitions} />]
          : null,

        <Resource name='bonusDraw' {...bonusDraw} />,
        <Resource name='general' {...general} />,
        <Resource name='blogs' {...blogs} />,
        // <Resource
        //   name='landing-general/:type'
        //   {...landingGeneral('DYNAMIC')}
        // />,
        <Resource name='weeklySubscriptionDraws' {...weeklySubscriptionDraw} />,
        <Resource name='win-general' {...landingGeneral('WIN')} />,
        <Resource name='discount-general' {...landingGeneral('DISCOUNT')} />,
        <Resource name='thesun-general' {...landingGeneral('THESUN')} />,
        <Resource name='deal-general' {...landingGeneral('DEAL')} />,
        <Resource name='offer-general' {...landingGeneral('OFFER')} />,
        <Resource name='widgets' {...widgets} />,
        <Resource name='specialOffers' {...specialOffers} />,
        <Resource name='competition' list={CompetitionDetails} />,
        <Resource name='reports' {...reports} />,
        <Resource name='categories' {...categories} />,
      ]}
    </Admin>
  );
};

export default App;
